<template>
	<div id="shangx">

		<div class="fflex ffbet">
			<ul class="fflex headBox">
				<li @click="jump('shanglei')">商品类型</li>
				<li @click="jump('gongys')">供应商</li>
				<li @click="jump('shangx')">商品信息</li>
				<li @click="jump('wuliu')">物流设置</li>
				<li class="active">出入库类型</li>
				<li @click="jump('rizhi')">日志列表</li>
			</ul>
			<div class="sousuok">
				<!--<el-input-->
				<!--size="mini"-->
				<!--placeholder="供应商查询"-->
				<!--v-model="gyshang"-->
				<!--&gt;-->

				<!--<i  class="el-icon-search el-input__icon"-->
				<!--slot="suffix"-->
				<!--v-on:click="searchname">-->
				<!--</i>-->
				<!--</el-input>-->
			</div>
		</div>

		<div class="fflex ffbet" style="margin: 10px 0;line-height: 32px;color: #999;align-items: center">

			<div>
				<span>选择状态：</span>
				<select name="" class="xiala " v-model="is_use" style="width: 120px;margin-right: 10px;margin-left: 5px">
					<option value="">请选择</option>
					<option value="1">禁用</option>
					<option value="2">启用</option>
				</select>

				<span>选择类型：</span>
				<select name="" class="xiala " v-model="type" style="width: 120px;margin-right: 10px;margin-left: 5px">
					<option value="">请选择</option>
					<option value="1">出库</option>
					<option value="2">入库</option>
				</select>
				<span>类型名称：</span>
				<input type="text" class="xiala" v-model="search" placeholder="类型名称查询" @keyup.enter="chaxun" style="width: 120px;margin-right: 10px;margin-left: 5px">
				<el-button type="warning" size="mini" @click="chaxun">查询</el-button>
			</div>


			<el-button type="warning" round size="mini" class="purBtnsz" @click="tan(1)">添加出入库类别</el-button>

		</div>

		<div class="tableBox">
			<table class="table table-bordered">
				<thead>
					<tr>
						<th>序号</th>
						<th>类别名称</th>
						<th>类型</th>
						<th>状态</th>
						<th>建档时间</th>
						<th>操作</th>
					</tr>
				</thead>
				<tbody>
					<tr  v-for="(ta,taindex) in tabledata" :key="taindex">
						<td>{{taindex+1}}</td>
						<td>
							{{ta.name}}
						</td>
						<td>{{ta.type|churu}}</td>
						<td>{{ta.is_use|qiyong}}</td>
						<td>{{ta.create_time}}</td>

						<td>
							<span class="tablebtnBox">
								<div class="qianziBtn-mini" v-if="ta.is_use==2" style="background:#b2b2b2;color: #fff" @click="jinfn(ta.id)">禁用</div>
								<div class="qianziBtn-mini" v-if="ta.is_use==1" style="background: rgb(0, 204, 228);color: #fff" @click="qifn(ta.id)">启用</div>
								<div class="shenziBtn-mini" @click="tan(3,ta.id)">修改</div>
								<div class="qianziBtn-mini" @click="delfn(ta.id)" style="    background: rgb(255, 121, 124);color: #fff">删除</div>
							</span>
						</td>
					</tr>
					<tr v-if="tabledata==''">
						<td colspan="6" align="center">暂无数据</td>
					</tr>
				</tbody>
			</table>

		</div>

		<div class="table-bottom">
			<div>
				<el-pagination @current-change="handleCurrentChange" :current-page="currentpage" :page-size="pageone" background
				 layout="prev, pager, next" :total="total">
				</el-pagination>
			</div>
		</div>

		<el-dialog class="tanchuang" :title="Ttitle" :visible.sync="shangxt" width="325px">

			<div>
				<el-row>
					<el-col :span="24" class="marBo2">
						<div class="demo-input-suffix">
							<span class="inputT" style="color: red"><span>*</span>类型名称：</span>
							<el-input style="width: 200px" placeholder="请输入类型名称" size="small" v-model="name2">
							</el-input>
						</div>

					</el-col>
					<el-col :span="24" class="marBo2">
						<span class="inputT" style="color: red"><span>*</span>选择类型：</span>
						<select name="" v-model="type2" class="xiala ">
							<option value="">请选择</option>
							<option value="1">出库</option>
							<option value="2">入库</option>
						</select>

					</el-col>


					<el-col :span="24" class="marBo2">
						<span class="inputT" style="color: red"><span>*</span>选择状态：</span>
						<select name="" v-model="is_use2" class="xiala ">
							<option value="">请选择</option>
							<option value="2">启用</option>
							<option value="1">禁用</option>
						</select>

					</el-col>






					<el-col :span="24" v-if="zhuang==3" style="text-align: center">
						<el-button type="warning" round size="mini" class="purBtnsz" @click="xiugai">确认修改</el-button>
					</el-col>

					<el-col :span="24" v-if="zhuang==1" style="text-align: center">
						<el-button type="warning" round size="mini" class="purBtnsz" @click="tianj">确认添加</el-button>
					</el-col>

				</el-row>
			</div>
		</el-dialog>





	</div>
</template>

<script>
	export default {
		data() {
			return {
				token: '',
				gyshang: '',
				currentpage: 1,
				pageone: 10,
				total: 100,
				shangxt: false,
				zhuang: '',
				Ttitle: '',
				dis: false,
				//            shangphone:''
				goodsleiop: [{
					value: '',
					label: '请选择'
				}, {
					value: '195',
					label: '非消耗品'
				}, {
					value: '196',
					label: '日常消耗品'
				}, {
					value: '197',
					label: '固定资产'
				}],
				goodslei: '',
				ylimg: 'https://saas.gymbaby.cn/static/qmsj/img/jinxiaocun/default2.jpg',
				imgbox: [],
				is_use: '',
				search: '',
				type: '',
				tabledata: '',
				name2: '',
				type2: '',
				is_use2: '',
				iid: '',
			};
		},
		filters: {

			churu: function(v) {
				if (v) {
					if (v == 1) {
						return '出库';
					} else if (v == 2) {
						return '入库';
					} else {
						return '';
					}
				}
			},
			qiyong: function(v) {
				if (v == 2) {
					return '启用';
				} else if (v == 1) {
					return '禁用';
				} else {
					return '';
				}
			}
		},


		methods: {
			xiugai: function() {
				let self = this;

				$.ajax({
					type: 'POST',
					url: process.env.apiUrl + 'saas/JxcOutStorage/update',
					dataType: 'json',
					data: {
						token: self.token,
						name: self.name2,
						id: self.iid,
						type: self.type2,
						is_use: self.is_use2
					},
					success: function(data) {
						if (data.status == 1) {
							self.$message({
								type: 'success',
								message: data.msg
							});
							self.shangxt = false
							self.gonggong();

						} else {
							self.$message({
								type: 'error',
								message: data.msg
							});
						}


					}
				})

			},
			chaxun: function() {
				let self = this;
				self.gonggong()
			},
			upimg: function() {
				let self = this;
				$('#img_upload').click()


			},
			fn: function(e) {
				//this.filebox.push(e.currentTarget.files);

				//ss

				this.ylimg = URL.createObjectURL(e.currentTarget.files[0])

			},
			tan: function(e, id) {
				let self = this;
				this.zhuang = e;
				if (this.zhuang == 1) {
					this.Ttitle = '添加出入库类别'
					this.dis = false;

				} else if (this.zhuang == 2) {
					this.Ttitle = '查看出入库类别'
					this.dis = true;
				} else {
					this.Ttitle = '修改出入库类别'
					this.dis = false;
					self.iid = id
					$.ajax({
						type: 'POST',
						url: process.env.apiUrl + 'saas/JxcOutStorage/edit',
						dataType: 'json',
						data: {
							token: self.token,
							id: id,

						},
						success: function(data) {
							self.name2 = data.data.name;
							self.type2 = data.data.type;
							self.is_use2 = data.data.is_use;


						}
					})





				}
				this.shangxt = true;
			},
			handleCurrentChange: function(i) {
				//            alert(i)
				let self = this;
				self.currentpage = i;
				self.gonggong()
			},
			jump: function(e) {
				this.$router.push({
					'name': e
				})
			},
			tianj: function() {
				let self = this;

				$.ajax({
					type: 'POST',
					url: process.env.apiUrl + 'saas/JxcOutStorage/store',
					dataType: 'json',
					data: {
						token: self.token,
						name: self.name2,
						type: self.type2,
						is_use: self.is_use2
					},
					success: function(data) {
						if (data.status == 1) {
							self.$message({
								type: 'success',
								message: data.msg
							});
							self.name2 = '';
							self.type2 = '';
							self.is_use2 = ''
							self.gonggong()
							self.shangxt = false;
						} else {
							self.$message({
								type: 'error',
								message: data.msg
							});
						}

					}
				})
			},
			delfn: function(id) {

				let self = this;
				this.$confirm('是否删除此信息?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {

					//这里请求ajax
					$.ajax({
						type: 'POST',
						url: process.env.apiUrl + 'saas/JxcOutStorage/delete',
						dataType: 'json',
						data: {
							id: id,
							token: self.token,
						},
						success: function(data) {
							if (data.status == 1) {
								self.$message({
									type: 'success',
									message: data.msg
								});
								self.gonggong()
							} else {

								self.$message({
									type: 'error',
									message: data.msg
								});

							}
						}
					})

				}).catch(() => {
					//                this.$message({
					//                    type: 'info',
					//                    message: '已取消删除'
					//                });
				});


			},
			jinfn: function(id) {

				let self = this;

				this.$confirm('是否要禁用', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {

					//这里请求ajax
					//                alert(id)
					$.ajax({
						type: 'POST',
						url: process.env.apiUrl + 'saas/JxcOutStorage/notallow',
						dataType: 'json',
						data: {
							id: id,
							token: self.token,
						},
						success: function(data) {
							if (data.status == 1) {


								self.$message({
									type: 'success',
									message: data.msg
								});
								self.gonggong()
							} else {

								self.$message({
									type: 'error',
									message: data.msg
								});

							}
						}
					})

					//                this.$message({
					//                    type: 'success',
					//                    message: '删除成功!'
					//                });
				}).catch(() => {
					//                this.$message({
					//                    type: 'info',
					//                    message: '已取消删除'
					//                });
				});


			},
			qifn: function(id) {



				let self = this;

				this.$confirm('是否要启用', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {

					//这里请求ajax
					//                alert(id)
					$.ajax({
						type: 'POST',
						url: process.env.apiUrl + 'saas/JxcOutStorage/allow',
						dataType: 'json',
						data: {
							id: id,
							token: self.token,
						},
						success: function(data) {
							if (data.status == 1) {
								self.$message({
									type: 'success',
									message: data.msg
								});
								self.gonggong()
							} else {
								self.$message({
									type: 'error',
									message: data.msg
								});

							}
						}
					})

					//                this.$message({
					//                    type: 'success',
					//                    message: '删除成功!'
					//                });
				}).catch(() => {
					//                this.$message({
					//                    type: 'info',
					//                    message: '已取消删除'
					//                });
				});

			},
			gonggong: function() {
				var self = this;
				$.ajax({
					type: 'POST',
					url: process.env.apiUrl + 'saas/JxcOutStorage/index',
					dataType: 'json',
					data: {
						page: self.currentpage,
						token: self.token,
						search: self.search,
						type: self.type,
						is_use: self.is_use

					},
					success: function(data) {

						if (data.status == 1) {
							self.tabledata = data.data;
							self.total = Number(data.map.count)
						} else if(data.status == 2){
							self.tabledata =''
							self.total = 0
						}

					}
				})
			}

		},
		mounted: function() {

			var self = this;
			self.token = $.cookie('token');
			$.ajax({
				type: 'POST',
				url: process.env.apiUrl + 'saas/JxcOutStorage/index',
				dataType: 'json',
				data: {
					page: self.currentpage,
					pageone: self.pageone,
					token: self.token,

				},
				success: function(data) {
					if (data.status == 1) {
						self.tabledata = data.data;
						self.total = Number(data.map.count)
					} else if(data.status == 2){
						self.tabledata = '';
						self.total = 0
					}

				}
			})

		}


	}
</script>

<style scoped>
	.xiala {
		width: 200px;
		height: 32px;
		line-height: 32px;
		background-color: #fff;
		background-image: none;
		border-radius: 4px;
		border: 1px solid #dcdfe6;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		color: #606266;
		display: inline-block;
		font-size: 13px;
		outline: 0;
		padding: 0 15px;
		-webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
		transition: border-color .2s cubic-bezier(.645, .045, .355, 1);

	}

	.yulantu {
		width: 100px;
		height: 100px;
		border-radius: 6px;
		margin-left: 10px;
	}

	ul {
		list-style: none;
	}

	#shangx p,
	label,
	ul {
		margin: 0;
		padding: 0;
	}

	.fflex {
		display: flex;
		display: -webkit-flex;
	}

	.ffbet {
		justify-content: space-between;
	}

	.ffend {
		justify-content: flex-end;
	}

	#shangx * {
		box-sizing: border-box;
	}

	#shangx {
		box-sizing: border-box;
		padding: 10px;
	}

	.headBox li {
		width: 75px;
		background: #E6BE8A;
		height: 30px;
		line-height: 30px;
		margin-right: 8px;
		border-radius: 5px 5px 0 0;
		text-align: center;
		color: #fff;

	}

	.headBox li.active {
		background: #ecebfd;
		color: #E6BE8A;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .2);
	}

	.purBtnsz {
		background: #E6BE8A !important;
		height: 26px;
		border: none !important;
	}

	.marBo2 {
		margin-bottom: 10px;
	}

	.inputT {
		display: inline-block;
		width: 100px;

	}
</style>
<style>


</style>



// WEBPACK FOOTER //
// src/pages/jinxc/churukl.vue